import faker from 'faker';

import {AcademicYear, Region, School} from '../../types';

const SEED = 123;

export const mockRegion = (
    override: Partial<Region> = {},
    overrideSeed: number = SEED
): Region => {
    faker.seed(overrideSeed);

    return {
        regionId: faker.datatype.number(),
        name: faker.name.findName(),
        ...override
    }
};

export const mockAcademicYear = (
    override: Partial<AcademicYear> = {},
    overrideSeed: number = SEED
): AcademicYear => {
    faker.seed(overrideSeed);

    return {
        year: 2021,
        startDate: '2021-10-16T00:00:00Z',
        endDate: '2022-10-16T00:00:00Z',
        isSchoolAcademicYear: faker.datatype.boolean(),
        academicYearId: faker.datatype.number(),
        ...override
    }
};

export const mockSchool = (
    override: Partial<School> = {},
    overrideSeed: number = SEED
): School => {
    faker.seed(overrideSeed);

    return {
        schoolId: faker.datatype.number(),
        crmId: faker.datatype.number(),
        name: `${faker.name.findName()} ${faker.name.lastName()}`,
        region: mockRegion(undefined, overrideSeed),
        academicYear: mockAcademicYear(undefined, overrideSeed),
        schoolAdmin: faker.name.firstName(),
        country: faker.address.country(),
        city: faker.address.city(),
        hasFutureSchoolAcademicYear: faker.datatype.boolean(),
        ...override
    }
};
